import { render, staticRenderFns } from "./AdminPrintParticipants.vue?vue&type=template&id=2c708c1a&"
import script from "./AdminPrintParticipants.vue?vue&type=script&lang=js&"
export * from "./AdminPrintParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports